import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { IResetPasswordFormStrategyComponent, IResetPasswordFormStrategyPresenter } from './interfaces';
import { ResetPasswordFormStrategyPresenter } from './reset-password-form-strategy.presenter';
import { AuthModalComponentEnum } from '../../../enums';
import { ButtonComponent, InputComponent } from '@shared/components';

@Component({
	selector: 'app-reset-password-form-strategy',
	templateUrl: './reset-password-form-strategy.component.html',
	styleUrls: ['./reset-password-form-strategy.component.scss'],
	standalone: true,
	imports: [
		CommonModule, 
		ReactiveFormsModule, 
		IonicModule, 
		ButtonComponent, 
		InputComponent
	],
})
export class ResetPasswordFormStrategyComponent
	extends IAbstractView<IResetPasswordFormStrategyPresenter>
	implements IResetPasswordFormStrategyComponent
{
	formGroup = this.presenter.formGroup;
	loading$ = this.presenter.loading$;
	loadingStore$ = this.presenter.loadingStore$;
	translations = this.presenter.translations;
	AuthModalComponentEnum = this.presenter.AuthModalComponentEnum;

	@Input({ required: true }) callback = this.presenter.callback;
	@Input() visitingCheckout = this.presenter.visitingCheckout;

	constructor(presenter: ResetPasswordFormStrategyPresenter) {
		super(presenter);
	}

	onRequestResetPassword(): void {
		this.presenter.onRequestResetPassword();
	}

	getFieldErrorMessage(fieldName: string): string {
		return this.presenter.getFieldErrorMessage(fieldName);
	}

	navigateTo(route: AuthModalComponentEnum): void {
		this.presenter.navigateTo(route);
	}

	getButtonType(isDisabled: boolean | null): 'button-primary' {
		return (isDisabled ? 'button-primary disabled' : 'button-primary') as unknown as 'button-primary';
	}
}
